import {Component, OnInit} from '@angular/core';
import {IonSlides, ModalController} from '@ionic/angular';
import {ModalComponent} from 'app/core/modal.component';
import {File} from 'app/entities/file.entity';

// DON'T FORGET INCLUDE MODULE OF MODAL INTO PAGE MODULE, or it will not work
@Component({
  selector: 'app-gallery-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class GalleryModalComponent extends ModalComponent implements OnInit {

  showControls = false;
  ionSlides: IonSlides;
  activeIndex = 0;
  cleanMode = false;

  files: File[] = [];

  slidesOptions = {
    slidesPerView: 1,
    loop: this.files.length > 1,
  };

  constructor(
    modalController: ModalController
  ) {
    super(modalController);
  }

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.showControls = true;
  }

  ionViewWillLeave() {
    this.showControls = false;
  }

  closeModal() {
    return super.closeModal({});
  }

  swiperReady(ionSlides, event) {

    // Проблема: Если один ion-slides вложен в другой ion-slides, это вызывает ошибку - окончание инициализации
    //  у ion-slides-потомка заставляет срабатывать ionSlidesDidLoad и у потомка и у родительского ion-slides.
    //  Решение: сравнивать источник эвента ionSlidesDidLoad и инстанс в котором он срабатывает чтобы исключить ложные срабатывания.
    if (event.target !== ionSlides.el) {
      return;
    }

    this.ionSlides = ionSlides as IonSlides;
    this.ionSlides.slideTo(this.activeIndex, 0, false);
  }

  slideChanged(event: any) {
    this.ionSlides?.getActiveIndex().then((index) => {
      this.activeIndex = index;
    });
  }

  getActiveFile() {
    return this.files[this.activeIndex];
  }
}
